import type { FC } from 'react';
import React from 'react';
import { MDText } from 'i18n-react';

import useVehicleFilterStore, { useFilters } from 'Stores/FilterStore/VehicleListFilter/VehicleListFilterStore';

import texts from '../../VehicleListV2.texts.json';
import { RangeFilterDropdown } from '../dropdowns/RangeFilterDropdown';
import type { RangeChipConfig, SingleValueRangeChipConfig } from '../FilterBarV2.consts';
import { applyRangeFilter, clearRangeFilter, getActiveLabel, getFilterNumericValue } from '../FilterBarV2.helpers';

import { FilterChip } from './FilterChip';

const LocalT = new MDText(texts);

export const RangeFilterChip: FC<{ chipConfig: RangeChipConfig | SingleValueRangeChipConfig }> = ({ chipConfig }) => {
	const filters = useFilters();
	const setValue = useVehicleFilterStore((store) => store.setValue);
	const unsetValue = useVehicleFilterStore((store) => store.unsetValue);
	const label = `${LocalT.translate(chipConfig.labelKey)}`;
	const activeLabel = getActiveLabel({ filterId: chipConfig.id, filters });
	const valueFrom =
		chipConfig.type === 'singleValueRange'
			? chipConfig.min
			: getFilterNumericValue({ filters, key: chipConfig.fromId });

	return (
		<FilterChip activeLabel={activeLabel} id={chipConfig.id} isActive={!!activeLabel} label={label}>
			{({ onClose, resetKey }) => (
				<RangeFilterDropdown
					key={resetKey}
					disabledFrom={chipConfig.type === 'singleValueRange'}
					increment={chipConfig.increment}
					label={label}
					max={chipConfig.max}
					min={chipConfig.min}
					onApply={(from, to) => applyRangeFilter({ config: chipConfig, from, setValue, to, unsetValue })}
					onClear={() => clearRangeFilter({ config: chipConfig, unsetValue })}
					onClose={onClose}
					unit={chipConfig.unit}
					valueFrom={valueFrom}
					valueTo={getFilterNumericValue({ filters, key: chipConfig.toId })}
				/>
			)}
		</FilterChip>
	);
};
